<template>
  <el-dialog
    :visible="show"
    append-to-body
    title="选择作品"
    :close-on-click-modal="false"
    width="700px"
    @close="closeDialog"
  >
    <div class="v-header">
      <el-select
        v-model="subjectId"
        v-loading="loadingSubject"
        size="mini"
        class="v-mr-5"
        style="width: 200px"
        placeholder="请选择主体"
      >
        <el-option
          v-for="item in subjectList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        v-model="keyword"
        class="v-form-item"
        size="mini"
        placeholder="作品名称"
        style="width: 170px"
      ></el-input>
      <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)"
        >搜索</el-button
      >
      <el-button class="v-ml-5" size="mini" @click="reset">重置</el-button>
    </div>
    <div v-loading="loading" class="v-content" style="height: 350px">
      <el-table border size="small" :data="lists" height="100%">
        <el-table-column prop="name" label="作品名称"></el-table-column>
        <el-table-column
          prop="categoryName"
          label="所属分类"
          width="130"
        ></el-table-column>
        <el-table-column label="操作" width="80" align="right">
          <template slot-scope="scope">
            <el-button size="min" type="primary" @click="doSelect(scope.row)">
              选择
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="v-footer">
      <el-pagination
        layout="total,sizes,prev, pager, next"
        :current-page.sync="page"
        :total="total"
        @size-change="
          (pageSize) => {
            getList(page, pageSize);
          }
        "
        @current-change="
          (page) => {
            getList(page);
          }
        "
      ></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      lists: [],
      isShowAddEdit: false,
      isShowAddScene: false,
      row: null,
      loading: false,
      keyword: "",
      userInfo: this.$store.state.user.userInfo,
      subjectId:"",
      subjectList: [],
				loadingSubject: false,
    };
  },

  created() {
    this.getList();
    this.getSubjectList();
  },

  methods: {
    async getSubjectList() {
				this.loadingSubject = true;
				try {
					let res = await this.api.subject.listsAll({type: 1});
					this.subjectList = res.data;
				} catch (e) {
					console.error(e);
				}
				this.loadingSubject = false;
			},
    //全景列表
    async getList(page, pageSize) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.pageSize = pageSize ? pageSize : this.pageSize;
      try {
        let res = await this.api.worksAdmin.lists({
          page: this.page,
          pageSize: this.pageSize,
          keyword: this.keyword,
          subjectId:this.subjectId
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    reset() {
      this.keyword = "";
      this.status = "";
      this.subjectId = "";
      this.getList(1);
    },

    closeDialog() {
      this.$emit("update:show", false);
    },

    doSelect(row) {
      this.$emit("select", { id: row.id, name: row.name });
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: flex-end;
}
</style>
